import UiModal from '../UiModal/UiModal'
import Form from '../../Form/Form'
import { ClassName } from '../../Form/const'
import { defaultRules } from '../../Form/default-rules'
import { Timer } from '../Timer/Timer'
import { getVkAuthModel } from '../VKConnect'
import { createElement, render } from '../../utils/render'
import { translate } from '../../utils/translations'
import { Media } from '../../utils/const';
import { saleEndDate } from '../SaleEndDate/SaleEndDate'

const ButtonText = {
  consultation: translate('form.button.consultation'),
  cloudpayments: translate('form.button.cloudpayments'),
  credit: translate('form.button.credit')
}

const getPaymentMethodTemplate = (data) => {
  const { name, description, hint, image } = data

  return (
    `<div class="ui-autopayment-method">
      <label class="ui-autopayment-method__label">
        <input
          name="payment_type"
          value="${name}"
          type="radio"
          class="ui-autopayment-method__input sr-only"
          data-analytics="${name}_installments"
          data-type="credit"
        >

        <span class="ui-autopayment-method__box">
          <span class="ui-autopayment-method__title f f--14">
            ${description}
          </span>

          ${image && (
            `<span class="ui-autopayment-method__images">
              <img
                src="${image}"
                alt="${hint}"
              >
            </span>`
          )}
        </span>
      </label>
    </div>`
  )
}

const getLoaderTemplate = () => {
  return (
    `<div class="autopay-form-modal__loader ui-loader">
      <svg
        class="ui-loader__icon"
        viewBox="0 0 100 100"
        fill="none"
      >
        <circle
          cx="50%"
          cy="50%"
          r="45"
          stroke="currentColor"
          class="ui-loader__circle"
        />
      </svg>
    </div>`
  )
}

export class AutopayFormModal extends UiModal {
  constructor(data) {
    const autoPaymentFormTemplate = document.querySelector('#autopay-form-modal')
      .content
      .cloneNode(true)
      .querySelector('.autopay-form-modal__wrapper')

    super(autoPaymentFormTemplate, {
      wrapperClass: 'autopay-form-modal',
      isIndent: false
    })

    this.loaderElement = null
    this.buttonWrapperElelent = null

    this.formElement = null
    this.formInstance = null

    this.timer = null
    this.paymentMethods = null
    this.data = data
    this.smMax = window.matchMedia(`(max-width: ${Media.SM_MAX}px)`)

    this.smMediaChangeHandler = this.smMediaChangeHandler.bind(this);
    this.formChangeHandler = this.formChangeHandler.bind(this)
    this.formSubmitHandler = this.formSubmitHandler.bind(this)
    this.modalScrollHandler = this.modalScrollHandler.bind(this)
    this.buttonClickHandler = this.buttonClickHandler.bind(this)
    this.formSentHandler = this.formSentHandler.bind(this);
  }

  async beforeMounted() {
    this.fillCardBlock(this.data)

    this.buttonWrapperElelent = this.element.querySelector('.autopay-form-modal__button-wrapper')
    this.formElement = this.element.querySelector('.form')
    this.formElement.type.value = this.data.type
    this.formElement['tariff_title'].value = this.data.title

    const vkConnectContainer = this.element.querySelector('[data-auth="vk-connect"]')
    const vkAuthModel = await getVkAuthModel([vkConnectContainer])
    this.formInstance = new Form(this.formElement, defaultRules, vkAuthModel, this.data.autopayment)
    this.formInstance.init()

    this.formInstance.onCloudPayment = this.formSentHandler

    if (this.smMax.matches) {
      this.setPaddingForButton(this.buttonWrapperElelent.offsetHeight)
      this.setShadowForButton(this.scrollingEl)
      this.scrollingEl.addEventListener('scroll', this.modalScrollHandler)
      this.buttonWrapperElelent.querySelector('.autopay-form-modal__button')
        .addEventListener('click', this.buttonClickHandler)
    }

    this.smMax.addEventListener('change', this.smMediaChangeHandler)
    this.formElement.addEventListener('change', this.formChangeHandler)
    this.formElement.addEventListener('form-sended', this.formSubmitHandler)

    if (this.data.autopayment?.public_ID && this.data.autopayment?.nomenclature_ID) {
      this.formElement['nomenclature_id'].value = this.data.autopayment.nomenclature_ID

      this.showPaymentMethods()
      await this.fetchPaymentMethods()
    } else {
      this.element.querySelector('.autopay-form-modal__step').remove()
      this.renderPaymentField()
    }
  }

  beforeUnmounted() {
    if (this.smMax.matches) {
      this.buttonWrapperElelent.querySelector('.autopay-form-modal__button')
        .removeEventListener('click', this.buttonClickHandler)
      this.scrollingEl.removeEventListener('scroll', this.modalScrollHandler)
    }

    this.smMax.removeEventListener('change', this.smMediaChangeHandler)
    this.formElement.removeEventListener('change', this.formChangeHandler)
    this.formElement.removeEventListener('form-sended', this.formSubmitHandler)
  }

  unmounted() {
    this.timer?.destroy()
  }

  async fetchPaymentMethods() {
    this.renderLoader()

    try {
      const response = await fetch(`/landgen/api/v1/payment-types/?credit_duration=${this.data.creditDuration}&country_id=${this.data.countryId}`)

      if (!response.ok) {
        await Promise.reject(response)
      }

      const { data } = await response.json()
      this.paymentMethods = data
      this.paymentMethods?.length && this.renderPaymentMethods(this.paymentMethods)
      this.removeLoader()
    } catch (e) {
      this.removeLoader()
      e.message = `[tariffs-autopay] ${e.message}`
      window.Sentry.captureException(e)
    }
  }

  smMediaChangeHandler(evt) {
    if (evt.matches) {
      this.setPaddingForButton(this.buttonWrapperElelent.offsetHeight)
      this.scrollingEl.addEventListener('scroll', this.modalScrollHandler)
      this.buttonWrapperElelent.querySelector('.autopay-form-modal__button')
        .addEventListener('click', this.buttonClickHandler)
    } else {
      this.setPaddingForButton()
      this.scrollingEl.removeEventListener('scroll', this.modalScrollHandler)
      this.buttonWrapperElelent.querySelector('.autopay-form-modal__button')
        .removeEventListener('click', this.buttonClickHandler)
    }

    this.setShadowForButton(this.scrollingEl)
  }

  setButtonText(type) {
    this.element
      .querySelector('.autopay-form-modal__button .ui-button__text')
      .textContent = ButtonText[type]
        ? ButtonText[type]
        : ButtonText.consultation
  }

  formChangeHandler(evt) {
    if (!evt.target.closest('.autopay-form-modal__types')) {
      return
    }

    const type = evt.target.dataset.type

    this.setButtonText(type)
  }

  formSubmitHandler() {
    window.$analytics?.push('tariff-submit', {
      tariffName: this.data.name
    })
  }

  formSentHandler() {
    this.close()
  }

  setPaddingForButton(offset) {
    this.element.querySelector('.autopay-form-modal__contacts')
      .style.paddingBottom = offset ? `${offset - 40}px` : 0
  }

  setShadowForButton(target) {
    this.smMax.matches && (target.scrollHeight - target.offsetHeight) !== target.scrollTop && !this.element.querySelector(`.${ClassName.SUCCESS}`)
      ? this.buttonWrapperElelent.classList.add('ui-shadow-8pt')
      : this.buttonWrapperElelent.classList.remove('ui-shadow-8pt')
  }

  modalScrollHandler(evt) {
    this.setShadowForButton(evt.target)
  }

  buttonClickHandler() {
    if (!this.formInstance.isValid) {
      this.scrollingEl.scrollTo({
        top: this.scrollingEl.scrollHeight,
        left: 0,
        behavior: 'smooth'
      })
    }
  }

  showPaymentMethods() {
    const title = this.element.querySelector('.autopay-form-modal__title')
    const discount = this.element.querySelector('#cloudpayment-discount')

    discount && (discount.textContent = this.data.price.discountAmountWithCountryDiscount)
    title.textContent = title.dataset.paymentTitle
    this.element.querySelector('.autopay-form-modal__step').style.display = 'block'
  }

  renderPaymentMethods(methods) {
    const fragment = document.createDocumentFragment()

    methods.forEach((method) => {
      const paymentMethodElement = createElement(getPaymentMethodTemplate(method))
      render(fragment, paymentMethodElement)
    })

    render(this.element.querySelector('.autopay-form-modal__types'), fragment)
  }

  renderPaymentField() {
    const paymentField = createElement('<input name="payment_type" value="consultation" type="hidden">')
    render(this.formElement, paymentField)
  }

  renderLoader() {
    this.loaderElement = createElement(getLoaderTemplate())
    render(this.element.querySelector('.autopay-form-modal'), this.loaderElement)
  }

  removeLoader() {
    if (this.loaderElement !== null) {
      this.loaderElement.remove()
      this.loaderElement = null
    }
  }

  fillCardBlock(data) {
    const card = this.element.querySelector('.autopay-price-block')

    const descriptions = data.descriptions.map((item) => {
      return `<li class="autopay-price-block__condition">${item}</li>`
    }).join('')

    const cardStr = card.outerHTML
      .replace(/#title#/g, data.title)
      .replace(/#sale#/g, data.sale)
      .replace(/#priceNew#/g, data.price.new)
      .replace(/#priceNewCurrency#/g, data.price.newCurrency)
      .replace(/#priceOld#/g, data.price.old)
      .replace(/#priceOldCurrency#/g, data.price.oldCurrency)
      .replace(/#bullets#/g, descriptions)

    const newCard = createElement(cardStr)

    if (data.sale) {
      const timerElement = newCard.querySelector('.autopay-price-block__sale--timer')

      data.isTimer
        ? this.startTimer(timerElement)
        : timerElement.remove()
    } else {
      newCard.querySelector('.autopay-price-block__sale-block').remove()
    }

    card.parentElement.replaceChild(newCard, card)
  }

  startTimer(timerWrapper) {
    saleEndDate.addObserver(time => {
      this.timer = new Timer({ time, timerWrapper })
    })
  }
}
